import React from "react";
import { Link } from "react-router-dom";

import "./Movie.css";
import tr from "../../assets/tr.svg";
import en from "../../assets/en.svg";

const Movie = props => {
  return (
    <React.Fragment>
      <Link to={"/film/" + props.id} className="Movie">
        <div className="Photo">
          <img
            src={"http://image.tmdb.org/t/p/w342" + props.image}
            alt={props.name + " " + props.nameTR}
          />
        </div>
        <div className="Dark"></div>
        <div className="Top">
          {props.date}
          <div className="Lang">
            <img src={tr} alt="Türkçe" />
            <img src={en} alt="İngilizce" />
          </div>
        </div>
        <p>
          {props.name !== props.nameTR && props.name}
          <br />
          <span>{props.nameTR}</span>
        </p>
      </Link>
    </React.Fragment>
  );
};

export default Movie;
